import React, { useState, useEffect } from 'react';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';
import RModal from '../../../components/Rsuite/Modal';
import api from '../../../services/api';
import { CustomButton } from '../../../components/CustomButton';
import { CustomCheckPicker } from '../../../components/CustomCheckPicker';
import { CustomInput } from '../../../components/CustomInput';
import { toastSuccess, toastError, toastInfo } from '../../../toasts';
import {
  FormContainer,
  SectionTitle,
  FormRow,
  FormGroup,
  Label,
  RequiredMark,
  HelperText,
} from './styles';
import { schemaFeriado } from '../schema/feriado.schema';

const EditarCadastrarFeriado = ({
  modal,
  close,
  feriado,
  setFeriados,
  id_empresa,
  mesesDoAno,
}) => {
  const [dia, setDia] = useState('');
  const [mes, setMes] = useState([]);
  const [horaI, setHoraI] = useState('');
  const [horaF, setHoraF] = useState('');
  const [descricao, setDescricao] = useState('');

  const bloquearLetras = (e) => {
    const teclasPermitidas = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];

    if (teclasPermitidas.includes(e.key)) {
      return;
    }

    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleDiaChange = (value) => {
    const apenasNumeros = value.replace(/\D/g, '');
    if (apenasNumeros.length <= 2) {
      if (apenasNumeros !== '' && +apenasNumeros > 31) {
        return;
      }
      setDia(apenasNumeros);
    }
  };

  const salvarFeriado = async () => {
    const inicioFormatado = horaI || '00:00:00';
    const fimFormatado = horaF || '00:00:00';

    if (!feriado) {
      schemaFeriado
        .validate({
          IdEmpresa: id_empresa,
          Descricao: descricao,
          Dia: +dia,
          Mes: +mes[0],
        })
        .then(async () => {
          const res = await api.post('feriado', {
            IdEmpresa: id_empresa,
            Descricao: descricao,
            Dia: +dia,
            Mes: +mes[0],
            Inicio: inicioFormatado,
            Fim: fimFormatado,
          });
          toastSuccess('Feriado cadastrado com sucesso!');
          setFeriados((state) => [...state, res.data]);
          close();
        })
        .catch((err) => toastError(err.errors));
    } else {
      schemaFeriado
        .validate({
          IdEmpresa: id_empresa,
          Descricao: descricao,
          Dia: +dia,
          Mes: +mes[0],
        })
        .then(async () => {
          const res = await api.patch(`feriado/${feriado.Id}`, {
            Descricao: descricao,
            Dia: +dia,
            Mes: +mes[0],
            Inicio: inicioFormatado,
            Fim: fimFormatado,
          });
          toastInfo('Feriado atualizado com sucesso!');
          setFeriados((state) =>
            state.map((e) => (e.Id !== res.data.Id ? e : res.data)),
          );
          close();
        })
        .catch((err) => toastError(err.errors[0]));
    }
  };

  useEffect(() => {
    if (feriado && modal) {
      setDia(feriado.Dia || '');
      setMes(feriado.Mes ? [feriado.Mes] : []);
      setHoraI(feriado.Inicio === '00:00:00' ? '' : feriado.Inicio || '');
      setHoraF(feriado.Fim === '00:00:00' ? '' : feriado.Fim || '');
      setDescricao(feriado.Descricao || '');
    } else if (!feriado && modal) {
      setDia('');
      setMes([]);
      setHoraI('');
      setHoraF('');
      setDescricao('');
    }
  }, [modal, feriado]);

  return (
    <RModal
      bodyWidth={380}
      open={modal}
      onClose={close}
      title={feriado ? 'Editar Feriado / Pausa' : 'Cadastrar Feriado / Pausa'}
      footer={
        <>
          <CustomButton onClick={salvarFeriado} appearance="primary">
            {feriado ? 'Salvar Alterações' : 'Cadastrar'}
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Cancelar
          </CustomButton>
        </>
      }
    >
      <FormContainer>
        <div>
          <SectionTitle>
            <FaCalendarAlt /> Data do Feriado / Pausa
          </SectionTitle>
          <FormRow style={{ marginBottom: '16px' }}>
            <FormGroup>
              <Label>
                Descrição <RequiredMark>*</RequiredMark>
              </Label>
              <CustomInput
                type="text"
                placeholder="Ex: Natal, Confraternização, Feriado Municipal..."
                value={descricao}
                onChange={setDescricao}
              />
            </FormGroup>
          </FormRow>

          <FormRow>
            <FormGroup>
              <Label>
                Dia <RequiredMark>*</RequiredMark>
              </Label>
              <CustomInput
                type="number"
                min="1"
                max="31"
                placeholder="Ex: 25"
                value={dia}
                onKeyDown={bloquearLetras}
                onChange={handleDiaChange}
              />
            </FormGroup>

            <FormGroup style={{ flex: 2 }}>
              <Label>
                Mês <RequiredMark>*</RequiredMark>
              </Label>
              <CustomCheckPicker
                placeholder="Selecione o mês"
                searchable={false}
                data={mesesDoAno}
                value={mes}
                onChange={(value) => {
                  if (value.length > 0) {
                    const ultimoSelecionado = value[value.length - 1];
                    setMes([ultimoSelecionado]);
                  } else {
                    setMes([]);
                  }
                }}
              />
            </FormGroup>
          </FormRow>
        </div>
        <div>
          <SectionTitle>
            <FaClock /> Horário de Fechamento
          </SectionTitle>
          <HelperText>
            Caso não informe o horário, o feriado ou a pausa será considerado como dia
            inteiro.
          </HelperText>
          <FormRow>
            <FormGroup>
              <Label>Hora inicial</Label>
              <CustomInput type="time" value={horaI} onChange={setHoraI} />
            </FormGroup>
            <FormGroup>
              <Label>Hora final</Label>
              <CustomInput type="time" value={horaF} onChange={setHoraF} />
            </FormGroup>
          </FormRow>
        </div>
      </FormContainer>
    </RModal>
  );
};

export default EditarCadastrarFeriado;
